<template>
  <TemplateModel>
    <div slot="body">
      <b-form-group class="text-left">
        <label class="label-login">E-mail</label>
        <b-form-input
          id="name"
          v-model="entity.email"
          :class="{ 'is-invalid': missingEmail }"
          class="_input"
          autofocus
          @keyup.enter="login"
        ></b-form-input>
      </b-form-group>

      <b-form-group class="text-left mb-0">
        <label class="label-login">Senha</label>
        <b-form-input
          id="senha"
          type="password"
          v-model="entity.password"
          :class="{ 'is-invalid': missingPassword }"
          class="_input"
          @keyup.enter="login"
        ></b-form-input>
      </b-form-group>
      <div class="text-left label-login mt-2 mb-3 fw-500">
        <router-link
          title="Esqueci a senha"
          class="primary-color"
          :to="{ name: 'forgotpassword' }"
          >Esqueci a senha</router-link
        >
      </div>
      <b-button
        block
        variant="danger"
        id="Btnlogin"
        class="login-button mb-3"
        :disabled="buttonDisabled"
        @click.prevent="login()"
        >Entrar</b-button
      >
    </div>
  </TemplateModel>
</template>

<script>
import { mapActions } from "vuex";
import md5 from "js-md5";

import TemplateModel from "../../template/TemplateLogin";
import BaseRequest, { setTokenHeader } from "../../request/request";
import localStore from "../../components/extra/LocalStorage";
import { loginPath } from "../../router/ApiPaths";

export default {
  name: "Login",
  data() {
    return {
      entity: {},
    };
  },
  mixins: [BaseRequest],
  components: {
    TemplateModel,
  },
  methods: {
    login() {
      if(!this.buttonDisabled)
      this.post(loginPath, {
        email: this.entity.email,
        password: md5(this.entity.password),
      }).then((data) => {
        setTokenHeader(data.token);
        this.setLogin({ user: data, token: data.token });
        localStore.setToken(data.token);
        this.$router.push({ path: "/" });
      });
    },
    ...mapActions({
      setLogin: "setLogin",
    }),
  },
  computed: {
    missingEmail: function () {
      return !this.entity.email;
    },
    missingPassword: function () {
      return !this.entity.password;
    },
    buttonDisabled: function () {
      return this.missingEmail || this.missingPassword;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/login/Login.vue